import type { CatalogTree } from '../types';

export const inbox = {
  list: {
    label: 'Konuşmalar',
    emptyNoFilter: 'Henüz konuşma yok. Bir kanal bağlayın.',
    emptyFiltered: 'Bu filtreye uyan konuşma yok.',
    clearFilters: 'Filtreleri temizle',
    assignee: 'Atanan: {name}',
    productCard: 'Ürün kartı',
  },
  filters: {
    status: 'Durum',
    channel: 'Kanal',
    assignee: 'Atanan',
    search: 'Ara',
    all: 'Tümü',
    me: 'Bana atananlar',
    unassigned: 'Atanmamış',
  },
  badges: {
    draft: 'Taslak',
    orderIntent: 'Sipariş niyeti',
    alwaysStaff: 'Her zaman personel',
  },
  view: {
    notFound: 'Böyle bir konuşma yok.',
    backToInbox: 'Gelen kutusuna dön',
    test: 'Deneme sohbeti',
    takeoverHint: 'Gönderince konuşmayı devralırsınız.',
  },
  owner: {
    ai: 'Asistan yanıtlıyor',
    staff: 'Personel',
  },
  actions: {
    takeover: 'Devral',
    returnToAi: 'Asistana geri ver',
    assign: 'Ata',
    outcome: 'Sonuç',
    close: 'Kapat',
    reopen: 'Yeniden aç',
    more: 'Daha fazla',
    addNote: 'Not ekle',
    linkOrder: 'Sipariş bağla',
    alwaysStaff: 'Her zaman personel',
    profile: 'Müşteri profili',
  },
  note: {
    title: 'Not ekle',
    label: 'Not',
    save: 'Kaydet',
  },
  linkOrder: {
    title: 'Sipariş bağla',
    search: 'Sipariş ara',
    empty: 'Sipariş bulunamadı.',
    confirmTitle: 'Siparişi bağla',
    confirm:
      'Sipariş {number} bu konuşmaya bağlanır ve kesin satış olarak sayılır; siparişin başka bir konuşmaya bağı varsa kaldırılır.',
    confirmLabel: 'Bağla',
  },
  orderDetails: {
    title: 'Sipariş bilgileri',
  },
} as const satisfies CatalogTree;
